import { useEffect, useState } from 'react';
import { type AiBuilderMessage, useAiBuilderChatActions, useAiBuilderChatComposerSignalState } from '../store';
import { AiBuilderActionChip } from './AiBuilderActionChip';
import { AiBuilderChatMessageAI } from './AiBuilderChatMessageAI';
import { AiBuilderInlineMarkdown } from './AiBuilderInlineMarkdown';
const AI_BUILDER_CONFIRM_ACTION_ATTENTION_DURATION_MS = 320;
export const AiBuilderConfirmMessage = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'confirm';
  }>;
}) => {
  const {
    submitConfirmMessage
  } = useAiBuilderChatActions();
  const {
    confirmActionAttentionMessageId,
    confirmActionAttentionRequestId
  } = useAiBuilderChatComposerSignalState();
  const [actionAttentionActive, setActionAttentionActive] = useState(false);
  useEffect(() => {
    if (message.submitted || confirmActionAttentionRequestId <= 0 || confirmActionAttentionMessageId !== message.id) {
      return;
    }
    setActionAttentionActive(true);
    const timeoutId = window.setTimeout(() => {
      setActionAttentionActive(false);
    }, AI_BUILDER_CONFIRM_ACTION_ATTENTION_DURATION_MS);
    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [confirmActionAttentionMessageId, confirmActionAttentionRequestId, message.id, message.submitted]);
  return <div className="flex flex-col gap-none" data-sentry-component="AiBuilderConfirmMessage" data-sentry-source-file="AiBuilderConfirmMessage.tsx">
      <AiBuilderChatMessageAI data-sentry-element="AiBuilderChatMessageAI" data-sentry-source-file="AiBuilderConfirmMessage.tsx">
        <AiBuilderChatMessageAI.Body className="flex-col gap-2xs break-words" data-sentry-element="unknown" data-sentry-source-file="AiBuilderConfirmMessage.tsx">
          <AiBuilderConfirmPrompt message={message} data-sentry-element="AiBuilderConfirmPrompt" data-sentry-source-file="AiBuilderConfirmMessage.tsx" />
        </AiBuilderChatMessageAI.Body>
        <AiBuilderChatMessageAI.Copy text={message.title} data-sentry-element="unknown" data-sentry-source-file="AiBuilderConfirmMessage.tsx" />
      </AiBuilderChatMessageAI>

      {!message.submitted && <div className="flex flex-col items-end gap-xs pb-md pl-3xl pr-lg">
          <AiBuilderActionChip label={message.approveLabel} attentionActive={actionAttentionActive} className="max-w-[416px]" onClick={() => submitConfirmMessage(message.id, 'approve')} title={message.approveLabel} />
          <AiBuilderActionChip label={message.cancelLabel} attentionActive={actionAttentionActive} className="max-w-[416px]" onClick={() => submitConfirmMessage(message.id, 'cancel')} title={message.cancelLabel} />
        </div>}
    </div>;
};
const AiBuilderConfirmPrompt = ({
  message
}: {
  message: Extract<AiBuilderMessage, {
    kind: 'confirm';
  }>;
}) => {
  return <>
      {message.title.split('\n').map((line, lineIndex) => <p key={`${message.id}-title-${lineIndex}`} className="text-body-lg-medium text-default">
          <AiBuilderInlineMarkdown text={line} />
        </p>)}
    </>;
};